export const iconFontAwesomeSportsFitnessPersonRunning = (
	<i className="fa-solid fa-person-running"></i>
);
